import React from 'react';
import type { Payment } from 'api/types';

const formatDate = (v?: string) => (v ? new Date(v).toLocaleDateString('en-IN') : undefined);

/**
 * Bank verification state of a payment (Advance-Folio design D3), with an
 * "Accounts" tag when Accounts recorded it in Fairbooks first (D5).
 *
 * Display only: an unverified advance still confirms the booking. The tooltip
 * carries the bank's value date and the verifier, which the badge alone hides.
 */
export const PaymentVerificationBadge: React.FC<{ payment: Pick<Payment,
  'verificationStatus' | 'origin' | 'bankValueDate' | 'verifiedByName' | 'verifiedAmount' | 'amount'> }> = ({ payment }) => {
  const { verificationStatus, origin, bankValueDate, verifiedByName, verifiedAmount, amount } = payment;

  const details = [
    bankValueDate && `Bank value date: ${formatDate(bankValueDate)}`,
    verifiedByName && `Verified by: ${verifiedByName}`,
    verificationStatus === 'DISCREPANCY' && verifiedAmount != null && verifiedAmount !== amount
      && `Bank confirmed ₹${verifiedAmount.toFixed(2)} against ₹${amount.toFixed(2)} recorded`,
  ].filter(Boolean).join('\n');

  const badge =
    verificationStatus === 'VERIFIED'
      ? { cls: 'badge-success', label: 'Verified' }
      : verificationStatus === 'DISCREPANCY'
        ? { cls: 'badge-danger', label: 'Discrepancy' }
        : { cls: 'badge-inactive', label: 'Unverified' };

  return (
    <span style={{ display: 'inline-flex', gap: '0.25rem', alignItems: 'center' }} title={details || undefined}>
      <span className={`badge ${badge.cls}`} style={{ fontSize: '0.7rem' }}>{badge.label}</span>
      {origin === 'FAIRBOOKS' && (
        <span className="badge badge-info" style={{ fontSize: '0.7rem' }} title="Recorded by Accounts in Fairbooks first — not posted again">
          Accounts
        </span>
      )}
    </span>
  );
};

export default PaymentVerificationBadge;
